
<template>
    
        <mars-view class="qa-containter"><mars-view class="qalist" :class="{'has-data': qalist && qalist.length > 0}"><article-item v-for="(row,i) in qalist" :key="i" :last="qalist.length === i + 1" :index="i" :data="row" :data-key="'regulation' + row.id" :data-page="'regulation'" :data-value="'regulation-qa-show'" :data-ext="JSON.stringify({id: row.id, index: i, qcNo: row.expertInfo.qualificationId})" :data-extswan="{id: row.id, index: i, qcNo: row.expertInfo.qualificationId}" class="article" :class="{'nopadding': i === 0}" @tapCallBack="tapCallBack"></article-item></mars-view><mars-view v-if="noQaResult && qalist" class="no-content">
        “抱歉，没有找到相关内容”
    </mars-view><mars-view v-if="noMoreResult && qalist && qalist.length > 0" class="info_top l-text-center c-font-normal c-color-gray">
        已显示全部内容
    </mars-view><mars-view v-if="bottomLoading" class="l-span-center"><mars-image class="bottom-loading-icon" :lazy-load="true" src="https://ss2.baidu.com/6ONYsjip0QIZ8tyhnq/it/u=2916203555,3196138030&fm=179&app=35&f=GIF?w=300&h=150&s=69C03262DFE7BB510C50D41B0000E0C1"></mars-image></mars-view></mars-view>
    
</template>

<script>
/* globals swan getApp */
import ArticleItem from "../../../components/home/articleItem.vue";
import { nav } from '../../../static/utils/navigate';
import { ubcClickInit } from '../../../static/utils/ubcMethods.js';
export default {
  props: {
    qalist: {
      type: Array,
      default() {
        return [];
      }
    },
    noMoreResult: {
      type: Boolean,
      default() {
        return false;
      }
    },
    bottomLoading: {
      type: Boolean,
      default() {
        return false;
      }
    },
    noQaResult: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  components: {
    'article-item': ArticleItem
  },
  methods: {
    tapCallBack(item, index) {
      ubcClickInit({
        page: 'regulations',
        value: 'regulations-qa-clk',
        ext: {
          id: item.xcxUrl.xcx_query,
          index,
          qcNo: item.expertInfo.qualificationId
        }
      });
      nav({
        url: `${item.xcxUrl.xcx_path}?${item.xcxUrl.xcx_query}`
      });
    }
  }
};
</script>

<style scoped>
.qalist {
  padding: 0 17px;
  background: #fff;
}
.has-data {
  margin-top: -15px;
}
.bottom-loading-icon {
  width: 100px;
  height: 50px;
}
.no-content {
  font-family: Arial, Helvetica, sans-serif;
  color: #999;
  text-align: center;
  padding: 20vw 0 17vw 0;
}
.info_top {
  background: #f5f5f5;
  color: #999;
  height: 54px;
  line-height: 54px;
  text-align: center;
}

</style>
